import {GetGraphicsResponse} from '../models/dto/getGraphics.response'
import {GetGraphicCaregoriesResponse} from '../models/dto/getGraphicCategories.response'
import {GetGraphicCaptionsResponse} from '../models/dto/getGraphicCaptions.response'
import {SaveGraphicCaptionsRequest} from '../models/dto/saveGraphicCaptions.request'
import {SaveGraphicCaptionsResponse} from '../models/dto/saveGraphicCaptions.response'
import {PixaBaySearchImagesRequest} from '../models/dto/pixaBaySearchImages.request'
import {PixaBaySearchImagesResponse} from '../models/dto/pixaBaySearchImages.response'
import network from './network'
import {GetGraphicResponse} from '../models/dto/getGraphic.response'
import {GetProductResponse} from '../models/dto/getProduct.response'
import {SaveProductRequest} from '../models/dto/saveProduct.request'
import {SaveProductResponse} from '../models/dto/saveProduct.response'
import {AddToCartRequest} from '../models/dto/addToCart.request'
import {AddToCartResponse} from '../models/dto/addToCart.response'
import {SavedEditor} from '../models/dto/common/savedEditor'
import {UploadImageResponse} from '../models/dto/uploadImage.response'
import heic2any from 'heic2any'
import {Config} from '../constants/Config'
import {img2CompressedWebp} from './helpers/img2CompressedWebp'

const SEARCH_IMAGES = 'pixabay'
const UPLOAD_IMAGE = 'kepfeltoltes'
const GET_GRAPHICS_ALL = 'grafikak'
const GET_GRAPHICS_CATEGORY = 'grafikak?kategoria={kat_id}'
const GET_GRAPHIC = 'grafikak/{id}'
const GET_GRAPHIC_CATEGORIES = '/grafika-kategoriak'
const GET_GRAPHIC_CAPTIONS = 'grafikak/{id}/feliratok'
const SAVE_GRAPHIC_CAPTIONS = 'grafikak/{id}/feliratok'
const GET_PRODUCT = `${Config.websiteUrl}/wp-content/themes/poloforma/get-termek.php?id={id}`
const SAVE_PRODUCT = 'termekek/{id}'
const SAVE_STORE_STATE = '/szerkeszto/mentes/{id}'
const ADD_TO_CART = 'kosarba'

class Services {
  searchImages = async (keyword: string) => {
    const params: PixaBaySearchImagesRequest = {
      keyword: keyword,
    }
    return network.get<PixaBaySearchImagesResponse>(SEARCH_IMAGES, {params})
  }

  uploadImage = async (file: File) => {
    const formData = new FormData()
    const fileName = file.name.toLowerCase()
    if (fileName.endsWith('.heic')) {
      const blob = (await heic2any({
        blob: file,
        toType: 'image/jpeg',
      })) as Blob
      const compressedImage = await img2CompressedWebp(blob)
      formData.append(
        'file',
        compressedImage,
        fileName.replace(/\.heic$/, '.jpg'),
      )
    } else {
      const compressedImage = await img2CompressedWebp(file)
      formData.append('file', compressedImage)
    }
    return network.post<UploadImageResponse>(UPLOAD_IMAGE, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  }

  getGraphics = async (categoryId: number | undefined) =>
    network.get<GetGraphicsResponse>(
      categoryId === undefined
        ? GET_GRAPHICS_ALL
        : GET_GRAPHICS_CATEGORY.replace('{kat_id}', categoryId.toString()),
    )

  getGraphicCategories = async () =>
    network.get<GetGraphicCaregoriesResponse>(GET_GRAPHIC_CATEGORIES)

  getGraphic = async (id: number) =>
    network.get<GetGraphicResponse>(GET_GRAPHIC.replace('{id}', id.toString()))

  getGraphicCaptions = async (id: number) =>
    network.get<GetGraphicCaptionsResponse>(
      GET_GRAPHIC_CAPTIONS.replace('{id}', id.toString()),
    )

  saveGraphicCaptions = async (
    id: number,
    captions: SaveGraphicCaptionsRequest,
  ) =>
    network.post<SaveGraphicCaptionsResponse>(
      SAVE_GRAPHIC_CAPTIONS.replace('{id}', id.toString()),
      captions,
    )

  getProduct = async (id: number) =>
    network.get<GetProductResponse>(GET_PRODUCT.replace('{id}', id.toString()))

  saveProduct = async (id: number, data: SaveProductRequest) =>
    network.post<SaveProductResponse>(
      SAVE_PRODUCT.replace('{id}', id.toString()),
      data,
    )

  saveStoreState = async (productId: number, data: SavedEditor) =>
    network.post(SAVE_STORE_STATE.replace('{id}', productId.toString()), data)

  getStoredState = async (id: string) =>
    network.get<SavedEditor>(`/szerkeszto/${id}`)

  addToCart = async (data: AddToCartRequest) =>
    network.post<AddToCartResponse>(ADD_TO_CART, data)
}

const services = new Services()
export default services
